import React, { FunctionComponent, PropsWithChildren, useEffect } from "react";
import { View } from "react-native";

import { Text } from "assets/components/text";
import { makeStyles } from "assets/theme";
import { Alert } from "assets/components/alert/Alert";
import {
  CheckboxInput,
  CheckboxInputMode,
} from "assets/components/checkbox/CheckboxInput";

import { useFormsImportStepperState } from "../forms-import-stepper-store";
import { getUserForms } from "../forms-import-stepper-actions";
import { LoadingOverlay } from "../../../components/LoadingOverlay";

export const FormsImportStep: FunctionComponent = () => {
  const styles = useStyles();
  const { steps, status, error } = useFormsImportStepperState();
  const defaultValues = steps.formsImport.userForms;
  const selectedForms = defaultValues?.filter((form) => form.checked);

  useEffect(() => {
    getUserForms();
  }, []);

  if (status === "error" && error) {
    return (
      <View style={styles.minHeight}>
        <Alert
          title={"Error"}
          intent="error"
          description={error.message}
          key={error.message}
        />
      </View>
    );
  }

  if (status === "loading") {
    return (
      <View style={styles.minHeight}>
        <LoadingOverlay />
      </View>
    );
  }

  const handleChange = (id: string, checked: boolean) => {
    const updatedValue = defaultValues?.map((form) =>
      form.id === id ? { ...form, checked } : form
    );

    useFormsImportStepperState.setState((prevState) => ({
      ...prevState,
      steps: {
        ...prevState.steps,
        formsImport: {
          ...prevState.steps.formsImport,
          userForms: updatedValue,
          invalid: !updatedValue?.filter((form) => form.checked).length,
        },
      },
    }));
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Import forms</Text>
      {selectedForms && selectedForms?.length > 0 && (
        <Text style={styles.contentTitle}>
          Number of forms to import {selectedForms?.length}
        </Text>
      )}
      <View style={styles.multiContainer}>
        {defaultValues &&
          defaultValues.length > 0 &&
          defaultValues.map((value) => (
            <CheckboxInput
              label={value.title}
              checked={value.checked}
              key={value.id}
              onPress={(checked) => handleChange(value.id, checked)}
              mode={CheckboxInputMode.OUTLINE}
            />
          ))}
      </View>
    </View>
  );
};
const useStyles = makeStyles((theme) => ({
  container: {
    flexDirection: "column",
  },
  title: {
    ...theme.fonts.medium,
    fontSize: 20,
    fontWeight: "600",
    paddingBottom: theme.getSpacing(2),
  },
  contentTitle: {
    ...theme.fonts.medium,
    fontWeight: "600",
    fontSize: 16,
    paddingBottom: theme.getSpacing(2),
  },
  multiContainer: {
    flexDirection: "column",
    display: "flex",
    gap: theme.getSpacing(2),
    maxHeight: 240,
    overflowY: "scroll",
  },
  minHeight: {
    minHeight: 150,
  },
}));
export default FormsImportStep;
